// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".notification-list--item[data-v-291bdd27]{padding-top:1rem;padding-bottom:1rem;border-bottom:1px solid #f5f5f5}.notification-list--item[data-v-291bdd27]:last-child{border-bottom:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
